<script>
  export let links
  export let template = ''

  const { Component, units = {}, props: commonProps = {} } = links

  function fillTemplate(template, replacers) {
    if (replacers === undefined) {
      return [template]
    }
    return Object.keys(replacers).reduce(
      (parts, key) => {
        return parts
          .map((part) => {
            const split = part.split(key)
            const splitPartsLength = split.length

            for (let idx = splitPartsLength - 1; idx > 0; idx--) {
              split.splice(idx, 0, key)
            }

            return split
          })
          .flat(Infinity)
      },
      [template]
    )
  }
</script>

{#each fillTemplate(template, units) as part, idx}
  {#if idx % 2 === 0}
    {part}
  {:else}
    <svelte:component this={Component} {...{ ...commonProps, ...(units[part].props || {}) }}>
      {units[part].text}
    </svelte:component>
  {/if}
{/each}
